/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/warenkorb-button/shop.warenkorb-button.component.ts.
 */
import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {Artikel} from '../../../../models/artikel';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';
import {BehaviorSubject, Subscription} from 'rxjs';
import {Warenkorb} from '../../../../models/warenkorb';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {DomainVertreterConfig} from '../../../../models/domain-vertreter-config';
import {AppShopService} from '../../../../services/app.shop.service';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {ShopWarenkorbMenuComponent} from '../warenkorb-menu/shop.warenkorb-menu.component';
import {AppUserService} from '../../../../services/app.user.service';
import {MerklistEntry} from '../../../../models/merklist-entry';
import {AppWarenkorbFlightService, WarenkorbFlightOrigin} from '../../../../services/app.warenkorb-flight.service';
import {GuiMessage} from '../../../../models/gui-message';

/**
 * Zweck: Beschreibt class ShopWarenkorbButtonComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'warenkorb-button',
    templateUrl: 'shop.warenkorb-button.component.html',
    styleUrls: ['shop.warenkorb-button.component.scss'],
    standalone: false
})
export class ShopWarenkorbButtonComponent {
  @ViewChild('primaryButton') primaryButton: ElementRef<HTMLButtonElement>;
  @Input() disabled = false;
  @Input() artikel: Artikel;
  @Input() view_slug: string;
  @Input() entry: WarenkorbEntry | MerklistEntry;
  @Input() vertreterconfig: BehaviorSubject<DomainVertreterConfig>;

  esub: Subscription;

  wksub: Subscription;
  add_mode = false;

  newwk: Warenkorb;

  buttonDisabled = new BehaviorSubject(false);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public wksvc: AppWarenkorbService, public ssvc: AppShopService, private bottomsheet: MatBottomSheet,
              private usvc: AppUserService, private flight: AppWarenkorbFlightService) {
  }

/**
 * Beschreibt Methode addToPrimaryWarenkorb und ihren Rückgabevertrag.
 */
  addToPrimaryWarenkorb(event?: MouseEvent, sourceOrigin?: WarenkorbFlightOrigin) {
    const button = (event?.currentTarget as HTMLElement | null) || this.primaryButton?.nativeElement;
    const rect = button?.getBoundingClientRect();
    const origin = sourceOrigin || (rect && rect.width > 0 && rect.height > 0
      ? {x: rect.left + rect.width / 2, y: rect.top + rect.height / 2}
      : null);
    this.buttonDisabled.next(true);
    setTimeout(() => {
      if (this.entry.menge && this.entry.menge > 0) {
        this.ssvc.addToPrimaryWarenkorb(this.entry, (message?: GuiMessage) => {
          this.buttonDisabled.next(false);
          if (origin && message?.state == 'success') {
            this.flight.flyFrom(origin);
          }
        });
      } else {
        this.buttonDisabled.next(false);
      }
    }, 100);
  }

/**
 * Beschreibt Methode addToWarenkorbDialog und ihren Rückgabevertrag.
 */
  addToWarenkorbDialog() {
    setTimeout(() => {
      this.ssvc.addToWarenkorbDialog(this.entry);
    }, 100);
  }

/**
 * Beschreibt Methode showMenu und ihren Rückgabevertrag.
 */
  showMenu(event, as_vertreter = false) {
    event.preventDefault();
    event.stopImmediatePropagation();

    setTimeout(() => {
      this.bottomsheet.open(ShopWarenkorbMenuComponent, {
        data: {
          artikel: this.artikel,
          entry: this.entry,
        }
      });
    }, 100);
  }


}
